export type SceneType = 'impact' | 'sensation' | 'bondage' | 'psychological' | 'primal' | 'mixed';
export type Intensity = 'light' | 'moderate' | 'heavy' | 'edge';
export type Duration = 'under-hour' | '1-3-hours' | 'longer';
export type Weight = 'light' | 'moderate' | 'heavy';
export type DropPattern = 'rare' | 'occasional' | 'common' | 'severe';
export type PhysicalNeed = 'warmth' | 'hydration' | 'food' | 'sleep' | 'movement';
export type EmotionalNeed = 'silence' | 'talking' | 'touch' | 'witnessing' | 'solitude';
export type TimeAvailable = '15min' | '30min' | '1hour' | 'overnight';

export interface AftercareInputs {
  sceneType: SceneType;
  intensity: Intensity;
  duration: Duration;
  emotionalWeight: Weight;
  dropPattern: DropPattern;
  physicalNeeds: PhysicalNeed[];
  emotionalNeeds: EmotionalNeed[];
  timeAvailable: TimeAvailable;
  recipeName?: string;
}

export interface TimelineStep {
  time: string;
  action: string;
}

export interface AftercarePlan {
  title: string;
  items: string[];
  first30: TimelineStep[];
  nextHours: TimelineStep[];
  nextDays: string;
  signature: string;
}

export interface SavedRecipe {
  id: string;
  name: string;
  inputs: AftercareInputs;
  plan: AftercarePlan;
  createdAt: string;
}

export const DEFAULT_INPUTS: AftercareInputs = {
  sceneType: 'mixed',
  intensity: 'moderate',
  duration: '1-3-hours',
  emotionalWeight: 'moderate',
  dropPattern: 'occasional',
  physicalNeeds: ['warmth', 'hydration'],
  emotionalNeeds: ['touch'],
  timeAvailable: '30min',
};
